import React,{useState,useEffect} from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReportCreate from "../chart/reportCreator";
import { getquipmentDetail } from "../../services/fire";
import Renderreport from "../report/renderreport"
//import Renderreport from "./renderreport";
const ConfirmSubmit = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,handleonClick,
  list,
  onDisAprove,
  value,
  onChange,
  error,size ="xl",
  Year,Month,Location

}) => {

  
const [datadetail, setdatadetail] = useState([]);
const [detailname, setdetailname] = useState('');

  const handleDetailClick = (even) =>{
    setdetailname(even)  
  }

  const onClickCancel = () =>{
    setdetailname('')
    onCancel();
  }

  useEffect(() => {
    if (!detailname){
      setdatadetail([])
      return;
    } 
    
    const loadData = async () => {
      
      const { data: result } = await getquipmentDetail(Year, Month,Location,detailname)   
        if (result) {
          setdatadetail(result);

        }
    };
    loadData();
  }, [detailname,Year,Month,Location]);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onClickCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader> 
        {header}
        {list && list.ComName && 
      
         <p className="font-weight-normal">
          {list.ComName}
       </p>
        }
        </ModalHeader>
        <ModalBody>

        {list && <div className="container">
      <div className="col-12">
        <div className="mt-1">
          {list.series !== undefined && (
            <ReportCreate
              data={list}
              type={"bar"}
              colors={["#0FF54A", "#F63809", "#F6D209"]}
              stacked="true"
              labelposition="top"
              onclick={handleDetailClick}
            />
          )}
        </div>
      </div>
    </div>}

    { datadetail &&
    <Renderreport
          list ={datadetail}
          
          />}
     
    {/* {setdetaillist && <div className="container">
      <div className="col-12">
        <div className="mt-1">
          {list.series !== undefined && (
            <ReportCreate
              data={list}
              type={"bar"}
              colors={["#0FF54A", "#F63809", "#F6D209"]}
              stacked="true"
              labelposition="top"
              onclick={handleonClick}
            />
          )}
        </div>
      </div>
    </div>} */}
         

         
        </ModalBody>
        { error && <div className="col-md-12 alert alert-danger">  { error}</div>}

        {list && list.comment &&
            <Button color="danger">
              {list.comment}
            </Button>
          }
        <ModalFooter>
   
       
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfirmSubmit;
